import { MinMax } from './min-max';
import { VehicleTypeInterface } from '../interfaces/api';

export class VehicleType implements VehicleTypeInterface {

    code: string;

    drivers: MinMax;

    id: number;

    height: MinMax;

    length: MinMax;

    name: string;

    weight: MinMax;

    width: MinMax;

    get icon(): string {
        return 'assets/imgs/icons/vehicle-types/' + this.code.toLowerCase() + '.svg'
    }

    static createFromObject(object: any): VehicleType {

        let type = new VehicleType();

        if (object.code !== undefined)      type.code = object.code;
        if (object.drivers !== undefined)   type.drivers = MinMax.createFromObject(object.drivers);
        if (object.id !== undefined)        type.id = object.id;
        if (object.height !== undefined)    type.height = MinMax.createFromObject(object.height);
        if (object.length !== undefined)    type.length = MinMax.createFromObject(object.length);
        if (object.name !== undefined)      type.name = object.name;
        if (object.weight !== undefined)    type.weight = MinMax.createFromObject(object.weight);
        if (object.width !== undefined)     type.width = MinMax.createFromObject(object.width);

        return type;
    }

    static createFromObjects(objects: any[]): VehicleType[] {
        let vehicleTypes: VehicleType[] = [];

        for (let object of objects) {
            vehicleTypes.push(VehicleType.createFromObject(object));
        }

        return vehicleTypes;
    }
}



// WEBPACK FOOTER //
// ./src/entities/vehicle-type.ts